module.exports = __webpack_public_path__ + "img/home-middle.cfd9343f.png";